<template>
  <div id="hrms6ae">
    <hrms-search-box-table v-show="indexDisp"
            v-model="searchIndex"
            :data="index"
            :nowLang="app.nowLang"
            :columns="columns[app.nowLang].index"
            :unLoadBool="true"
            :receivedStore="receivedHrms6aeIndex"
            searchBoxAlias="request-subrogate"
            :addEvent="addEvent"
            :editEvent="editEvent"
            :cancelEvent="cancelEvent" />

    <detail v-show="detailDisp"
            :labels="labels[app.nowLang]"
            :labelsButton="app.button[app.nowLang]"
            :detail="detail"
            :nowLang="app.nowLang"
            :toggle="toggle"
            :postHrms6aeSave="postHrms6aeSave"
            :columnsDetail="columns[app.nowLang].detail"
            :columnsDetailPopup="columns[app.nowLang].detailPopup"
            :indexSelected="indexSelected"
            :receivedHrms6aeDetailSearch="receivedHrms6aeDetailSearch"
            :maxRowspanDetail="maxRowspan.detail"
            :maxRowspanPopup="maxRowspan.detailPopup"
            :searchDetail="searchDetail"
            :saveButtonDisp="saveButtonDisp"
            :searchIndex="searchIndex"
            :currentCodempid="codempid" />
  </div>
  
</template>

<script>
import { mapGetters, mapMutations, mapActions } from 'vuex'
import * as types from 'store/modules/hrms6ae/mutation-types'
import detail from 'components/hrms6ae/detail'
import moment from 'moment'
import swal from 'sweetalert'
import { constLabels } from 'assets/js/constLabels.js'

export default {
  name: 'hrms6ae',
  data () {
    return {
      app: this.$parent.$parent.$parent,
      searchIndex: {
        dtereqst: '01/' + moment().format('MM/YYYY'),
        dtereqen: moment().format('DD/MM/YYYY')
      },
      searchDetail: {
        dteworkst: moment().format('DD/MM/YYYY'),
        dteworken: moment().format('DD/MM/YYYY'),
        codempid_query: this.$parent.$parent.$parent.currentUser.p_codempid
      }
    }
  },
  created () {
    this.receivedHrms6aeColumnsLabels()
  },
  computed: {
    codempid () {
      let currentUser = this.app.currentUser
      return currentUser.p_codempid
    },
    ...mapGetters({
      indexDisp: types.GET_HRMS6AE_INDEX_DISP,
      detailDisp: types.GET_HRMS6AE_DETAIL_DISP,
      maxRowspan: types.GET_HRMS6AE_MAX_ROWSPAN,
      columns: types.GET_HRMS6AE_COLUMNS,
      labels: types.GET_HRMS6AE_LABELS,
      index: types.GET_HRMS6AE_INDEX,
      indexSelected: types.GET_HRMS6AE_INDEX_SELECTED,
      currentNumseq: types.GET_HRMS6AE_CURRENT_NUMSEQ,
      detail: types.GET_HRMS6AE_DETAIL,
      detailSearch: types.GET_HRMS6AE_DETAIL_SEARCH,
      saveButtonDisp: types.GET_HRMS6AE_SAVE_BUTTON_DISP
    })
  },
  methods: {
    pageDetail (event) {
      switch (event) {
        case 'add':
          this.searchDetail.dteworkst = moment().format('DD/MM/YYYY')
          this.searchDetail.dteworken = moment().format('DD/MM/YYYY')
          this.searchDetail.codempid = ''
          this.searchDetail.codempid_query = ''
          this.receivedHrms6aeDetailSearch(this.searchDetail)
          this.toggle('detail')
          break
        case 'edit':
          if (this.indexSelected.numseq) {
            this.setSaveButtonDisp(true)
            if (this.indexSelected.staappr === 'A' || this.indexSelected.staappr === 'Y' || this.indexSelected.staappr === 'N') {
              this.setSaveButtonDisp(false)
              swal({
                title: constLabels('warningTitle'),
                text: constLabels('HR1490'),
                confirmButtonText: constLabels('ok')
              })
            }
            this.receivedHrms6aeDetail(this.indexSelected)
            this.toggle('detail')
          }
          break
        default:
          break
      }
    },
    addEvent (param) {
      this.pageDetail('add')
    },
    editEvent (param) {
      this.setIndexSelected(param)
      this.pageDetail('edit')
    },
    cancelEvent (param) {
      this.setIndexSelected(param)
      if (this.indexSelected.staappr === 'P') {
        let sendParams = {
          p_codempid_query: this.indexSelected.codempid_query,
          dtereq: this.indexSelected.dtereq,
          numseq: this.indexSelected.numseq,
          dtework: this.indexSelected.dtework,
          staappr: this.indexSelected.staappr
        }
        this.postHrms6aeCancel({ cancelParams: sendParams, searchParams: this.searchIndex })
      } else if (this.indexSelected.staappr === 'C') {
        swal({
          title: constLabels('warningTitle'),
          text: constLabels('HR1506'),
          confirmButtonText: constLabels('ok')
        })
      } else {
        swal({
          title: constLabels('warningTitle'),
          text: constLabels('HR1490'),
          confirmButtonText: constLabels('ok')
        })
      }
    },
    ...mapMutations({
      setIndexSelected: types.SET_HRMS6AE_INDEX_SELECTED,
      setSaveButtonDisp: types.SET_HRMS6AE_SAVE_BUTTON_DISP
    }),
    ...mapActions({
      toggle: types.TOGGLE_HRMS6AE_PAGE,
      receivedHrms6aeColumnsLabels: types.RECEIVED_HRMS6AE_COLUMNS_LABELS,
      receivedHrms6aeIndex: types.RECEIVED_HRMS6AE_INDEX,
      receivedHrms6aeCurrentNumseq: types.RECEIVED_HRMS6AE_CURRENT_NUMSEQ,
      receivedHrms6aeDetail: types.RECEIVED_HRMS6AE_DETAIL,
      receivedHrms6aeDetailSearch: types.RECEIVED_HRMS6AE_DETAIL_SEARCH,
      postHrms6aeSave: types.POST_HRMS6AE_SAVE,
      postHrms6aeCancel: types.POST_HRMS6AE_CANCEL
    })
  },
  components: {
    detail
  }
}
</script>

<style src="./style.scss" lang='scss'></style>



// WEBPACK FOOTER //
// component.vue?3686a731